import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {NotificationSetting} from '../../../../../models/user';
import {UserService} from '../../../../services/user.service';
import {AchooPopupComponent} from '../../../../core/achoo-popup/achoo-popup.component';
import {ModalService} from '../../../../services/modal/modal.service';
import {ObjectUtils} from '../../../../utils/object.utils';

export enum ActivitySetting {
  INSTANTLY = 'instantly',
  NEVER = 'never'
}

export enum PeriodicSetting {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  NEVER = 'never'
}

@Component({
  selector: 'notification-setting',
  templateUrl: './notification-setting.component.html',
  styleUrls: ['./notification-setting.component.scss']
})
export class NotificationSettingComponent implements OnInit {
  public readonly activitySettings = [
    {id: ActivitySetting.INSTANTLY, name: this.translate.instant('notification_settings.activity.instantly')},
    {id: ActivitySetting.NEVER, name: this.translate.instant('notification_settings.activity.never')}
  ];
  public readonly updateSettings = [
    {id: PeriodicSetting.WEEKLY, name: this.translate.instant('notification_settings.updates.weekly')},
    {id: PeriodicSetting.MONTHLY, name: this.translate.instant('notification_settings.updates.monthly')},
    {id: PeriodicSetting.NEVER, name: this.translate.instant('notification_settings.updates.never')}
  ];
  public readonly pendingActions = [
    {id: PeriodicSetting.DAILY, name: this.translate.instant('notification_settings.pending_action.daily')},
    {id: PeriodicSetting.WEEKLY, name: this.translate.instant('notification_settings.pending_action.weekly')},
    {id: PeriodicSetting.MONTHLY, name: this.translate.instant('notification_settings.pending_action.monthly')},
    {id: PeriodicSetting.NEVER, name: this.translate.instant('notification_settings.pending_action.never')}
  ];
  public readonly promotionalContents = [
    {id: PeriodicSetting.WEEKLY, name: this.translate.instant('notification_settings.promotional_content.weekly')},
    {id: PeriodicSetting.MONTHLY, name: this.translate.instant('notification_settings.promotional_content.monthly')},
    {id: PeriodicSetting.NEVER, name: this.translate.instant('notification_settings.promotional_content.never')}
  ];
  @ViewChild('NotificationSettings')
  notificationSettings: AchooPopupComponent;
  private _notificationSettingsModalRef;
  @Input()
  public notificationSetting: NotificationSetting;
  // keep the latest update to check if users have been changed their settings
  private latestUpdateSetting: NotificationSetting;
  // show a notification after updating user notification settings
  public notificationStatus: string;
  public notificationMessage: string;
  // notification Ref
  private notificationRef;
  constructor(private translate: TranslateService, private userService: UserService, private modalService: ModalService) { }

  ngOnInit() {
    this.latestUpdateSetting = ObjectUtils.deepClone(this.notificationSetting);
  }

  saveNotificationSetting(errorCallback?) {
    this.userService.saveNotificationSetting(this.notificationSetting).subscribe((res) => {
      this.notificationStatus = this.translate.instant('notification.success');
      this.notificationMessage = this.translate.instant('notification_settings.update_success');
      this.modalService.closeSinglePopup(this._notificationSettingsModalRef);
      this._notificationSettingsModalRef = this.modalService.openMultipleModal(this.notificationSettings);
    }, (err) => {
      if (errorCallback) {
        errorCallback(err);
      } else {
        this.notificationStatus = this.translate.instant('notification.error');
        this.notificationMessage = this.translate.instant('notification_settings.update_error');
        this.modalService.closeSinglePopup(this._notificationSettingsModalRef);
        this._notificationSettingsModalRef = this.modalService.openMultipleModal(this.notificationSettings);
      }
    });
  }

  closeNotification() {
    if (this.notificationRef) {
      this.modalService.closeSinglePopup(this.notificationRef);
    }
  }

  public hasChangedNotificationSettings() {
    if (!this.latestUpdateSetting) {
      return true;
    }
    return (this.latestUpdateSetting.activity !== this.notificationSetting.activity)
      || (this.latestUpdateSetting.pendingAction !== this.notificationSetting.pendingAction)
      || (this.latestUpdateSetting.updates !== this.notificationSetting.updates);
  }

}



// WEBPACK FOOTER //
// ./src/app/main/account-setting/user-settings/notification-setting/notification-setting.component.ts